export const CORE_PRODUCT = 'core';
export const SOFTWARE_PRODUCT = 'software';
export const SERVICE_DESK_PRODUCT = 'servicedesk';
export const jiraIssueFormCreateEndpoint =
	'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?'; // the 1 query param is "requestTypeId"
export const EXPORT_URL = '/jira/forms/export';
export const ISSUE_FORMS_GENERAL_URL = '/jira/forms/create';
